import { ButtonSeverity } from 'primeng/button';

export enum ButtonType {
  Default,
  Primary,
  Success,
  Info,
  Warning,
  Danger,
  Link,
  DefaultOutline,
  PrimaryOutline,
  SuccessOutline,
  InfoOutline,
  WarningOutline,
  DangerOutline,
  LinkOutline,
  DefaultText,
  DangerText,
}

export enum ButtonSize {
  Default = 'small',
  Large = 'large',
  Small = 'small',
}

export enum PrimeVariant {
  Outlined = 'outlined',
  Text = 'text',
}

export interface PrimeNGButtonStyle {
  severity?: ButtonSeverity;
  variant?: PrimeVariant;
}

export const PrimeButtonStyle: Record<ButtonType, PrimeNGButtonStyle> = {
  [ButtonType.Primary]: { severity: 'info' },
  [ButtonType.PrimaryOutline]: { severity: 'info', variant: PrimeVariant.Outlined },
  [ButtonType.Success]: { severity: 'success' },
  [ButtonType.SuccessOutline]: { severity: 'success', variant: PrimeVariant.Outlined },
  [ButtonType.Info]: { severity: 'info' },
  [ButtonType.InfoOutline]: { severity: 'info', variant: PrimeVariant.Outlined },
  [ButtonType.Warning]: { severity: 'warn' },
  [ButtonType.WarningOutline]: { severity: 'warn', variant: PrimeVariant.Outlined },
  [ButtonType.Danger]: { severity: 'danger' },
  [ButtonType.DangerOutline]: { severity: 'danger', variant: PrimeVariant.Outlined },
  [ButtonType.Link]: { severity: 'info', variant: PrimeVariant.Text },
  [ButtonType.LinkOutline]: { severity: 'info', variant: PrimeVariant.Outlined },
  [ButtonType.Default]: { severity: 'secondary' },
  [ButtonType.DefaultOutline]: { severity: 'secondary', variant: PrimeVariant.Outlined },
  [ButtonType.DefaultText]: { severity: 'secondary', variant: PrimeVariant.Text },
  [ButtonType.DangerText]: { severity: 'danger', variant: PrimeVariant.Text },
};
